import React from 'react';
import { useTranslation } from 'react-i18next';
import { HighStandardDesc1, HighStandardDesc2, HighStandardDesc3 } from '../../Constants';
import { Icon } from '../elements/icon';

const HighStandards = () => {
  const { t } = useTranslation();
  return (
    <div className="t-w-full t-flex t-flex-col t-items-center t-gap-3 t-py-2">
      <div className="t-flex t-flex-col t-items-start t-gap-3">
        {[t(HighStandardDesc1), t(HighStandardDesc2), t(HighStandardDesc3)].map((text, i) => (
          <div key={i} className="t-flex t-items-center t-gap-2">
            <Icon name="tealCheckCircle" size={20} />
            <p className="t-m-0 t-font-sans t-text-[14px] t-font-medium t-text-navy">{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HighStandards;
